import {createStore, combineReducers, applyMiddleware, compose} from 'redux'
import thunkMiddleware from 'redux-thunk'
import { reducer as Auth } from './modules/auth/'
import { reducer as User } from './modules/user/'
import { reducer as Log } from './modules/log/'
import { reducer as Goods } from './modules/goods/'
import { reducer as Universal } from './universal/'

const middlewares = [thunkMiddleware]

const reducer = combineReducers({
  auth: Auth,
  user: User,
  log: Log,
  goods: Goods,
  universal: Universal
})

const storeEnhancers = compose(
  applyMiddleware(...middlewares),
  (window && window.devToolsExtension) ? window.devToolsExtension() : (f) => f,
)

export default createStore(reducer, {}, storeEnhancers)



// WEBPACK FOOTER //
// ./src/Store.js